import * as React from 'react';
import Modal from 'antd/lib/modal/Modal';
import Text from 'antd/lib/typography/Text';
import { AppStoreBuildComponent } from './appStoreBuilds/AppStoreBuildComponent';
import { AppStoreBuild } from '../types';
import { antGrey, runwayColors } from './styles/globalStyles';
import Flex from 'antd/lib/flex';

export interface PromoteBuildConfirmationModalProps {
    isVisible: boolean;
    isLoading: boolean;
    appStoreBuilds: AppStoreBuild[];
    trackName: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const PromoteBuildConfirmationModal: React.FC<PromoteBuildConfirmationModalProps> = ({
    isVisible,
    isLoading,
    appStoreBuilds,
    trackName,
    onConfirm,
    onCancel,
}) => {
    const isMultiple = appStoreBuilds.length > 1;
    const buildText = isMultiple ? 'builds' : 'build';

    const buildComponents = appStoreBuilds.map((appStoreBuild, index) => (
        <AppStoreBuildComponent
            key={appStoreBuild.appStoreBuild.id}
            styleOverrides={{
                backgroundColor: runwayColors.white,
                border: `1px solid ${antGrey.grey5}`,
                marginBottom: index < appStoreBuilds.length - 1 ? 8 : 0,
            }}
            appStoreBuild={appStoreBuild.appStoreBuild}
            associatedCIBuild={appStoreBuild.associatedCIBuild}
        />
    ));

    const actionTitle =
        isMultiple ?
            `Promote ${appStoreBuilds.length} builds to ${trackName} track`
        :   `Promote build #${appStoreBuilds[0]?.appStoreBuild.buildNumber} to ${trackName} track`;

    return (
        <Modal
            title={actionTitle}
            open={isVisible}
            okButtonProps={{ loading: isLoading }}
            okText={actionTitle}
            onOk={onConfirm}
            onCancel={onCancel}
            destroyOnClose
        >
            <Flex vertical>
                <div style={{ paddingBottom: 16 }}>{buildComponents}</div>
                <Text>
                    The selected {buildText} will be promoted to the <Text strong>{trackName}</Text> track.
                </Text>
            </Flex>
        </Modal>
    );
};
